import type { DomainManifest } from 'modules/core/lib/manifests/types'

import { useCreateLeave } from 'modules/timeoff/lib/oneHandlers/leave/create-leave'

import { sidebarManifest } from './sidebar'

export const manifest = {
  sidebar: (navigation) => ({
    items: sidebarManifest(navigation),
  }),
  one: {
    createActions: {
      leave: {
        actionResolver: useCreateLeave,
        policies: [],
        module: 'timeoff',
      },
    },
  },
} as const satisfies DomainManifest
